import Button from "../../atoms/Button";
import SVGS from "../../atoms/svgs";
import "./styles.scss";
import classnames from "classnames";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const BenefitsCard = (props) => {
  const BenefitsCardClassNames = classnames("BenefitsCard", {
    "BenefitsCard--mobileColumns": props.mobileColumns,
  });

  return (
    <div
      className={`${BenefitsCardClassNames} BenefitsCard--${props.type} BenefitsCard--${props.className}`}>
      {props.title && (
        <h3 className="BenefitsCard__title">
          {props.title} <br />
          {props.domainData ? props.domainData.data.domain : <Skeleton width={150} />}
        </h3>
      )}
      {props.benefits.map(function (benefit, index) {
        const Icon = benefit.svg ? SVGS[benefit.svg] : null;
        return (
          <div
            key={`benefit-card-${index}`}
            className="BenefitsCard__item">
            {benefit.svg && (
              <Icon
                className="BenefitsCard__itemIcon"
                title={benefit.title}
              />
            )}
            {benefit.title && (
              <div
                className="BenefitsCard__itemTitle"
                dangerouslySetInnerHTML={{ __html: benefit.title }}></div>
            )}
          </div>
        );
      })}
      {props.button && (
        <div className="BenefitsCard__button">
          <Button
            primary
            full
            label={props.button.label}
            link={props.button.link}
            dataQa={props.button.dataQa ? props.button.dataQa : "landing-home-test"}
          />
        </div>
      )}
    </div>
  );
};

export default BenefitsCard;
